import { format, parse } from 'date-fns';
import { tz } from '@date-fns/tz';

export type FlashSaleRotation = {
  startDate: string;
  endDate: string;
  collectionName: string;
  campaignUrl: string;
};

/**
 * Checks if the current time falls within a rotation's time range
 */
const isRotationActive = (rotation: FlashSaleRotation, now: Date, pattern: string, timezone: string): boolean => {
  const startDateTime = parse(rotation.startDate, pattern, new Date(), { in: tz(timezone) });
  const endDateTime = parse(rotation.endDate, pattern, new Date(), { in: tz(timezone) });

  return now >= startDateTime && now < endDateTime;
};

/**
 * Gets the active flash sale rotation based on current time in the given timezone
 *
 * @param rotations Array of flash sale rotations to check
 * @param timezone Timezone string (e.g. 'Asia/Singapore')
 * @param pattern Optional custom date-fns parse pattern. Defaults to 'yyyy-MM-dd HH:mm:ss'
 * @returns The active rotation if found, null otherwise
 */
export const getActiveFlashSaleRotation = (
  rotations: FlashSaleRotation[],
  timezone: string,
  pattern = 'yyyy-MM-dd HH:mm:ss',
): FlashSaleRotation | null => {
  const now = new Date();

  return rotations.find((rotation) => isRotationActive(rotation, now, pattern, timezone)) ?? null;
};
